import React from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import Add from "./New";
import EditMembers from "./Edit";
import MembersList from "./List";
import MembersDetails from "./Details";
import AddProductCategory from "./New";

function Index() {
  return (
    <Routes>
      <Route
        element={
          <>
            <Outlet />
          </>
        }
      >
        <Route
          path="list"
          element={
            <>
              <MembersList />
            </>
          }
        />
        <Route
          path="new"
          element={
            <>
              <AddProductCategory />
            </>
          }
        />
        <Route
          path="edit/:primary_id"
          element={
            <>
              <EditMembers />
            </>
          }
        />
        <Route
          path="details/:primary_id"
          element={
            <>
              <MembersDetails />
            </>
          }
        />

        <Route index element={<Navigate to="/product_category/list" />} />
      </Route>
    </Routes>
  );
}

export default Index;
